var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"columns is-centered is-mobile"},[_c('ul',{staticClass:"list column is-8"},[_c('li',{staticClass:"list-item"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }